export const getTokenClaim = ({ accessToken, claim }) => {
	try {
		//** Decode an access token check the value of a claim passed in */
		const oktaToken =
			typeof accessToken === "object"
				? JSON.stringify(accessToken)
				: accessToken;
		const arrayToken = oktaToken?.split(".");

		const tokenPayload = JSON.parse(atob(arrayToken[1]));
		return tokenPayload[claim] || false;
	} catch (ex) {
		console.log("Error occurred - ", ex);
	}
};
